











































































import Vue from "vue";
import { Worker } from "../../interfaces/Worker";
import { IndividualCareProviderByType } from "@/@modules/tarif-covid/interfaces/IndividualCareProvider";
import { Period } from "@/@modules/tarif-covid/interfaces/Period";
import PaymentsDetailsCounter from "@/@modules/tarif-covid/views/payment-details/PaymentsDetailsCounter.vue";
export default Vue.extend({
  components: {
    PaymentsDetailsCounter,
  },
  props: {
    worker: {
      type: Object as () => Worker,
      required: true,
    },
    individualCareProviders: {
      type: Array as () => IndividualCareProviderByType[],
      required: true,
    },
    periods: {
      type: Array as () => Period[],
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isCitizen: Boolean,
  },
  data() {
    return {
      expanded: [],
    };
  },
  computed: {
    getHeaders(): any[] {
      return [
        { text: this.$tc("tarif-covid.date"), value: "cashingDate" },
        { text: this.$tc("tarif-covid.period"), value: "exercise" },
        { text: this.$tc("tarif-covid.paymentAmount"), value: "amount" },
        !this.isCitizen ? { text: this.$tc("tarif-covid.paymentStatus"), value: "state" } : {},
        { text: this.$tc("tarif-covid.iban"), value: "foreignBankAccount" },
        { text: this.$tc("tarif-covid.communication"), value: "communication" },
        { text: this.$tc("tarif-covid.rejectReason"), value: "returnMotivation" },
        { text: "", value: "data-table-expand" },
      ];
    },
    getItems(): any {
      return this.worker?.workerVCs?.flatMap(workerVC => {
        return workerVC.financialFlows?.flatMap(financialFlow => {
          return Object.assign(financialFlow, {
            exercise: `20${workerVC.exercise}`,
          });
        });
      });
    },
  },
  methods: {
    getRunRefByLiquidationId(id: number): any {
      const period = this.periods.find(period => {
        return period.runs?.find(run => {
          return run.runInfos?.find(runInfo => {
            return runInfo.liquidations.find(liquidation => {
              return liquidation.id == id;
            });
          });
        });
      });
      if (period && period.runs) {
        return {
          of: {
            code: period?.code,
          },
          nr: period?.runs.find(run => {
            return run.runInfos?.find(runInfo => {
              return runInfo.liquidations.find(liquidation => {
                return liquidation.id == id;
              });
            });
          })?.nr,
        };
      }
    },
  },
});
